
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import {
  FiGrid,
  FiSend,
  FiUsers,
  FiTrendingUp,
  FiDownload,
  FiSettings,
  FiChevronDown,
  FiLogOut,
  FiX,
  FiClock,
  FiCreditCard,
  FiDollarSign,
  FiRepeat,
  FiMessageCircle,
  FiBarChart2,
} from "react-icons/fi";

import { FaQrcode } from "react-icons/fa";

export default function SideNav({ isOpen, onClose, isCollapsed }) {
  const [tooltip, setTooltip] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  const toggleSubmenu = (label) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [label]: !prev[label]
    }));
  };

  const groups = [
    {
      items: [
        {
          label: "Home",
          path: "/dashboard",
          icon: FiGrid,
          end: true
        },
        {
          label: "Users",
          path: "/dashboard/users",
          icon: FiUsers
        },
        {
          label: "Package Request",
          icon: FiSend,
          submenu: [

            {
              label: "Pending Package Request",
              path: "/dashboard/package-request"
            },
            {
              label: "Package Request History",
              path: "/dashboard/package-request-history"
            },
            {
              label: "Self Activation Wallet",
              path: "/dashboard/selfactivationwallet"
            },
            {
              label: "Transfer Self Wallet",
              path: "/dashboard/transfer-self-wallet"
            },
            {
              label: "Self Activation Wallet Transactions",
              path: "/dashboard/selfactivationwallettransaction"
            }
          ]
        },


        {
          label: "Withdrawal",
          icon: FiDownload,
          submenu: [

            {
              label: "Withdrawal Request",
              path: "/dashboard/payout-request"
            }
          ]
        },
        {
          label: "Wallet",
          icon: FiCreditCard,
          submenu: [

            {
              label: "Wallet Transfer List",
              path: "/dashboard/wallet-transfer"
            }
          ]
        },
        {
          label: "Referral Income",
          icon: FiUsers,
          submenu: [

            {
              label: "Referral Income List",
              path: "/dashboard/referral-income"
            }
          ]
        },
        {
          label: "Auto Pool",
          icon: FiRepeat,
          submenu: [

            {
              label: "Auto Pool Distribution",
              path: "/dashboard/autopool-income"
            },
            {
              label: "Auto Pool List",
              path: "/dashboard/autopool-list"
            },
            {
              label: "Auto Pool Income Record",
              path: "/dashboard/autopool-payment"
            }
          ]
        },

        {
          label: "Admin Support",
          icon: FiMessageCircle,
          submenu: [

            {
              label: "Add Admin Support",
              path: "/dashboard/add-admin-support"
            },
            {
              label: "Admin Support List",
              path: "/dashboard/admin-support"
            }
          ]
        },

        {
          label: "QR Code",
          path: "/dashboard/qr",
          icon: FaQrcode
        },


      ]
    }
  ];
  const closeMobile = () => {
    if (window.innerWidth < 992) onClose();
  };

  const showTooltip = (e, label) => {
    if (!isCollapsed || window.innerWidth < 992) return;

    const rect = e.currentTarget.getBoundingClientRect();

    setTooltip({
      label,
      top: rect.top + rect.height / 2,
      left: rect.right + 14
    });
  };

  const hideTooltip = () => setTooltip(null);

  // Open confirmation popup
  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  // Confirm logout
  const confirmLogout = () => {
    localStorage.clear();
    setShowLogoutModal(false);
    navigate("/");
  };

  // Cancel logout
  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      {isOpen && (
        <div
          className="gi-sidebar-backdrop"
          onClick={onClose}
        />
      )}

      <aside
        className={`gi-sidebar ${isOpen ? "gi-sidebar-open" : ""
          } ${isCollapsed ? "gi-sidebar-collapsed" : ""
          }`}
      >
        <div className="gi-sidebar-head">
          <NavLink
            to="/dashboard"
            className="gi-sidebar-logo"
            onClick={closeMobile}
          >
            <span className="gi-sidebar-logo-mark">
              <img src={logo} alt="Global Innovation" style={{ width: "30px", height: "30px" }} />
            </span>

            <span>
              <strong>Global Inavation</strong>

            </span>
          </NavLink>

          <button
            type="button"
            className="gi-sidebar-mobile-close"
            onClick={onClose}
            aria-label="Close navigation"
          >
            <FiX />
          </button>
        </div>

        <nav
          className="gi-sidebar-nav"
          aria-label="Dashboard navigation"
        >
          {groups.map((group) => (
            <div
              className="gi-nav-group"
              key={group.title}
            >
              <div className="gi-nav-group-title">
                {group.title}
              </div>

              {group.items.map((item) => {
                const Icon = item.icon;

                const hasSubmenu =
                  item.submenu &&
                  item.submenu.length > 0;

                const isSubmenuActive =
                  hasSubmenu &&
                  item.submenu.some(
                    (subItem) =>
                      location.pathname === subItem.path
                  );

                const isOpen =
                  openSubmenus[item.label] ||
                  isSubmenuActive;

                /* ================= SUBMENU ================= */

                if (hasSubmenu) {
                  return (
                    <div
                      className="gi-nav-submenu-wrapper"
                      key={item.label}
                    >
                      <button
                        type="button"
                        className={`gi-nav-link gi-nav-submenu-toggle ${isSubmenuActive
                          ? "gi-nav-link-active"
                          : ""
                          }`}
                        onClick={() =>
                          toggleSubmenu(item.label)
                        }
                        onMouseEnter={(e) =>
                          showTooltip(e, item.label)
                        }
                        onMouseLeave={hideTooltip}
                      >
                        <span className="gi-nav-icon">
                          <Icon />
                        </span>

                        <span className="gi-nav-label">
                          {item.label}
                        </span>

                        <FiChevronDown
                          className={`gi-nav-submenu-arrow ${isOpen
                            ? "gi-nav-submenu-arrow-open"
                            : ""
                            }`}
                        />
                      </button>

                      <div
                        className={`gi-nav-submenu ${isOpen
                          ? "gi-nav-submenu-open"
                          : ""
                          }`}
                      >
                        {item.submenu.map(
                          (subItem) => (
                            <NavLink
                              key={subItem.path}
                              to={subItem.path}
                              onClick={closeMobile}
                              className={({ isActive }) =>
                                `gi-nav-submenu-link ${isActive
                                  ? "gi-nav-submenu-link-active"
                                  : ""
                                }`
                              }
                            >
                              <span className="gi-nav-submenu-dot"></span>

                              <span>
                                {subItem.label}
                              </span>
                            </NavLink>
                          )
                        )}
                      </div>
                    </div>
                  );
                }
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    end={item.end}
                    onClick={closeMobile}
                    onMouseEnter={(e) =>
                      showTooltip(e, item.label)
                    }
                    onMouseLeave={hideTooltip}
                    className={({ isActive }) =>
                      `gi-nav-link ${isActive
                        ? "gi-nav-link-active"
                        : ""
                      }`
                    }
                  >
                    <span className="gi-nav-icon">
                      <Icon />
                    </span>

                    <span className="gi-nav-label">
                      {item.label}
                    </span>

                    {item.badge && (
                      <span className="gi-nav-badge">
                        {item.badge}
                      </span>
                    )}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>

        <div className="gi-sidebar-bottom">


          <button
            type="button"
            className="gi-sidebar-logout"
            onClick={handleLogout}
          >
            <FiLogOut />
            <span>Sign out</span>
          </button>
        </div>
      </aside>

      {createPortal(
        <div
          className={`gi-nav-tooltip-portal ${tooltip
            ? "gi-nav-tooltip-visible"
            : ""
            }`}
          style={
            tooltip
              ? {
                top: tooltip.top,
                left: tooltip.left
              }
              : undefined
          }
        >
          {tooltip?.label}
        </div>,
        document.body
      )}

      {showLogoutModal &&
        createPortal(
          <div
            className="gi-logout-overlay"
            onClick={cancelLogout}
          >
            <div
              className="gi-logout-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="gi-logout-close"
                onClick={cancelLogout}
                aria-label="Close"
              >
                <FiX />
              </button>

              <div className="gi-logout-icon">
                <FiLogOut />
              </div>

              <h3>Sign out?</h3>

              <p>
                Are you sure you want to sign out of
                your account?
              </p>

              <div className="gi-logout-actions">
                <button
                  type="button"
                  className="gi-logout-cancel"
                  onClick={cancelLogout}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="gi-logout-confirm"
                  onClick={confirmLogout}
                >
                  <FiLogOut />
                  Sign out
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};



